export default {"src":"/_next/static/media/insuranceLogo4.b8535de2.svg","height":40,"width":145,"blurWidth":0,"blurHeight":0};